import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const parkinsons: AnswerPathTreeNode = {
  path: 'parkinsons',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredParkinsonsDetails }],
};
